import Vue from 'vue'
import Scrollspy from 'vue2-scrollspy/dist'
// use default options
Vue.use(Scrollspy)
